export default __webpack_public_path__ + "static/media/office_W113EI90.aa6b0e51.jpg";